import React from "react";
import { Box } from "@mui/material";
interface LoginLayoutProps {
  children: React.ReactNode;
}

const LoginLayout: React.FC<LoginLayoutProps> = ({ children }) => (
  <Box
    sx={{
      width: "100%",
      height: "100vh",
      bgcolor: "#E5E9F3",
      position: "relative",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      p: 2,
    }}
  >
    <Box sx={{ position: "absolute", top: 16, left: 16 }}>
      <img
        src={`${process.env.PUBLIC_URL}/LogoPWA.svg`}
        alt={"logoAlt"}
        style={{ maxWidth: "100%", height: "auto" }}
      />
    </Box>

    <Box
      sx={{
        width: "100%",
        maxWidth: 400,
        bgcolor: "#FFFFFF",
        borderRadius: 2,
        boxShadow: 3,
        p: 4,
      }}
    >
      {children}
    </Box>
  </Box>
);

export default LoginLayout;
